import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderModesAdapter = getAdapter({ idFieldName: 'value' });

const orderModesSlice = createSlice({
  name: 'orderModes',
  initialState: orderModesAdapter.getInitialState(),
  reducers: {
    setOrderModes: (state, { payload: { orderModes } }) => {
      orderModesAdapter.setAll(state, orderModes);
    },
  },
});

const selectors = orderModesAdapter.getSelectors(({ orderModes }) => orderModes);

export const getOrderModes = (state) => selectors.selectAll(state);

export const {
  setOrderModes
} = orderModesSlice.actions;

export default orderModesSlice.reducer;